"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@chakra-ui/icons");
var _layout = require("@chakra-ui/layout");
var _react = require("@chakra-ui/react");
var _FaFile = require("@react-icons/all-files/fa/FaFile");
var _FaFilePdf = require("@react-icons/all-files/fa/FaFilePdf");
var _FaFolder = require("@react-icons/all-files/fa/FaFolder");
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _react2 = _interopRequireWildcard(require("react"));
var _reactDropzone = require("react-dropzone");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _url = require("../../../common/url");
var _uuid2 = require("../../../common/uuid");
var _ContextModal = _interopRequireDefault(require("../../molecules/ContextModal"));
var _FileContextMenu = _interopRequireDefault(require("../../molecules/FileContextMenu"));
var _FileInfoBox = _interopRequireDefault(require("../../molecules/FileInfoBox"));
var _FileList = _interopRequireDefault(require("../../molecules/FileList"));
var _Toolbar = _interopRequireDefault(require("../../molecules/Toolbar"));
var _getFileType = require("../../../common/getFileType");
var _mimeTypes = require("../../../common/mimeTypes");
var _ImagePreviewWarningAlert = _interopRequireDefault(require("../../molecules/ImagePreviewWarningAlert"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Finder = ({
  mode = 'browser',
  ...props
}) => {
  const toast = (0, _react.useToast)();
  const folderCreateContextModal = (0, _react.useDisclosure)();
  const itemRenameContextModal = (0, _react.useDisclosure)();
  const [showInfoCard, setShowInfoCard] = (0, _react2.useState)(false);
  const infoCardToggle = () => setShowInfoCard(!showInfoCard);
  let [data, setData] = (0, _react2.useState)(props.data);
  _react2.default.useEffect(() => {
    setData(props.data);
  }, [props.data]);
  const updateData = newData => {
    setData(newData);
    props.onDataChanged(newData);
  };
  const [rootUUID, setRootUUID] = (0, _react2.useState)(props.rootUUID);
  const [parentNodeHistory, setParentNodeHistory] = (0, _react2.useState)([{
    index: rootUUID,
    text: data[rootUUID].name
  }]);
  const [selectedFiles, setSelectedFiles] = (0, _react2.useState)([]);
  const [contextMenu, setContextMenu] = (0, _react2.useState)(null);
  const imagesWithoutPreview = (0, _react2.useMemo)(() => {
    const imagesWithoutPreview = [];
    for (const [uuid, item] of Object.entries(data)) {
      const fileItem = item;
      if (fileItem.mimeType && fileItem.mimeType.startsWith('image/')) {
        if (!fileItem.previewSrc) {
          imagesWithoutPreview.push(uuid);
        }
      }
    }
    return imagesWithoutPreview;
  }, [data]);
  const switchParentNode = uuid => {
    // find uuid in parentNodeHistory and remove it and all following elements
    const index = parentNodeHistory.findIndex(item => item.index === uuid);
    if (index !== -1) {
      setParentNodeHistory(parentNodeHistory.slice(0, index + 1));
    } else {
      setParentNodeHistory(parentNodeHistory.concat({
        index: uuid,
        text: data[uuid].name
      }));
    }
    setRootUUID(uuid);
    // add uuid to parentNodeHistory state
  };

  const resolveUUIDFromIndex = index => {
    const folder = data[rootUUID];
    return folder.childUUIDs[index] || rootUUID;
  };
  const handleSelectionChange = ids => {
    setSelectedFiles(ids);
  };
  const handleContextMenu = (event, id) => {
    setContextMenu({
      id,
      spawnX: event.clientX,
      spawnY: event.clientY
    });
  };
  const handleMove = (dragUUID, dropUUID) => {
    const folder = data[rootUUID];

    // Push dragUUID to data[dropUUID].childUUIDs without duplicates
    const droppable = data[dropUUID];
    if (!droppable.childUUIDs.includes(dragUUID)) {
      // Remove dragUUID from folder.childUUIDs
      const newRootChildUUIDs = folder.childUUIDs.filter(uuid => uuid !== dragUUID);
      const newData = (0, _immutabilityHelper.default)(data, {
        [rootUUID]: {
          childUUIDs: {
            $set: newRootChildUUIDs
          }
        },
        [dropUUID]: {
          childUUIDs: {
            $push: [dragUUID]
          }
        }
      });
      updateData(newData);
      toast({
        title: `Moved item`,
        status: 'info',
        isClosable: true,
        position: 'bottom-right'
      });
    }
  };
  const handleListMove = (dragIndex, dropIndex) => {
    const dragUUID = resolveUUIDFromIndex(dragIndex);
    const dropUUID = resolveUUIDFromIndex(dropIndex);
    handleMove(dragUUID, dropUUID);
  };
  const handleBreadcrumbMove = (dragIndex, dropUUID) => {
    const dragUUID = resolveUUIDFromIndex(dragIndex);
    handleMove(dragUUID, dropUUID);
  };
  const handleUpload = async (acceptedFiles, fileRejections) => {
    toast.closeAll();
    if (fileRejections.length > 0) {
      for (const fileRejection of fileRejections) {
        toast({
          title: `Uploading ${fileRejection.file.name} rejected`,
          description: fileRejection.errors.map(error => error.message).join(', '),
          status: 'error',
          isClosable: true,
          position: 'bottom-right'
        });
      }
    }
    const todayDate = new Date().toDateString();
    const files = {};
    for (const [i, file] of acceptedFiles.entries()) {
      const {
        name,
        size
      } = file;

      // resolve mime type from file content
      const fileType = await (0, _getFileType.getFileType)(file);
      console.log(fileType);

      // convert size to kb or mb
      const kb = size / 1024;
      const mb = kb / 1024;
      const sizeString = mb > 1 ? `${mb.toFixed(2)} MB` : `${kb.toFixed(2)} KB`;

      // check if file is bigger than 2mb if so toast a warning
      if (mb > 1.5) {
        toast({
          title: `${name} is a heavy file`,
          description: `Uploading a file bigger than 2mb might result in performence issues, please consider uploading a smaller file`,
          status: 'warning',
          isClosable: true,
          position: 'bottom-right'
        });
      } else {
        toast({
          title: `Uploading ${name}`,
          description: `${sizeString}`,
          status: 'info',
          isClosable: true,
          position: 'bottom-right'
        });
      }
      const fileName = name.split('.')[0];
      const uploaded = await props.onUploadFile(file);
      files[(0, _uuid2.uuidv4)()] = {
        name: fileName,
        createdAt: todayDate,
        modifiedAt: todayDate,
        src: uploaded.src,
        previewSrc: uploaded.previewSrc,
        mimeType: fileType.mime,
        size: sizeString
      };
      toast({
        title: `Uploaded ${name} (${i + 1}/${acceptedFiles.length})`,
        status: 'success',
        isClosable: true,
        position: 'bottom-right'
      });
    }
    let newData;
    for (const [uuid, file] of Object.entries(files)) {
      // if file is image create preview if not already created

      newData = (0, _immutabilityHelper.default)(data, {
        [rootUUID]: {
          childUUIDs: {
            $push: [uuid]
          }
        }
      });
      newData = (0, _immutabilityHelper.default)(newData, {
        [uuid]: {
          $set: file
        }
      });
    }
    if (newData) {
      updateData(newData);
    }
  };
  const handleFileInfoBoxUpdate = details => {
    const uuid = resolveUUIDFromIndex(selectedFiles[0]);
    const todayDate = new Date().toDateString();

    // update details of uuid item
    const newData = (0, _immutabilityHelper.default)(data, {
      [uuid]: {
        name: {
          $set: details.fileName
        },
        description: {
          $set: details.description
        },
        modifiedAt: {
          $set: todayDate
        }
      }
    });
    updateData(newData);
  };
  const handleFinishFolderCreate = name => {
    const todayDate = new Date().toDateString();

    // Create new folder
    const uuid = (0, _uuid2.uuidv4)();
    let newData = (0, _immutabilityHelper.default)(data, {
      [rootUUID]: {
        childUUIDs: {
          $push: [uuid]
        }
      }
    });
    newData = {
      ...newData,
      [uuid]: {
        isFolder: true,
        name,
        createdAt: todayDate,
        modifiedAt: todayDate,
        childUUIDs: []
      }
    };

    // Update data with new folder
    updateData(newData);
    toast({
      title: `Created folder`,
      status: 'success',
      isClosable: true,
      position: 'bottom-right'
    });
    folderCreateContextModal.onClose();
  };
  const handleItemRename = name => {
    // Get uuid from selected item
    const uuid = resolveUUIDFromIndex(selectedFiles[0]);
    const todayDate = new Date().toDateString();

    // Rename uuid and update modfiedAt
    const newData = (0, _immutabilityHelper.default)(data, {
      [uuid]: {
        name: {
          $set: name
        },
        modifiedAt: {
          $set: todayDate
        }
      }
    });
    updateData(newData);
    itemRenameContextModal.onClose();
  };

  //#region > Context Menu handlers
  const handleFileOpen = () => {
    // get uuid of selected file
    const uuid = resolveUUIDFromIndex(selectedFiles[0]);
    const item = data[uuid];
    setContextMenu(null);
    if (item.isFolder) {
      switchParentNode(uuid);
    } else {
      if (mode === 'selector') {
        if (props.onSelectorSelect) {
          const fileItem = item;
          // check if url is valid

          if ((0, _url.isValidHttpUrl)(fileItem.src)) {
            props.onSelectorSelect(uuid, fileItem);
          }
        }
      } else {
        props.onItemOpen(uuid);
      }
    }
  };
  const handleFileRename = () => {
    setContextMenu(null);
    itemRenameContextModal.onOpen();
    //props.onItemRename(contextMenu.id)
  };

  const handleFileDelete = () => {
    setContextMenu(null);

    // Unset uuid from data and update data[rootUUID].childUUIDs
    const uuid = resolveUUIDFromIndex(selectedFiles[0]);
    const newData = (0, _immutabilityHelper.default)(data, {
      $unset: [uuid],
      [rootUUID]: {
        childUUIDs: arr => arr.filter(_uuid => _uuid !== uuid)
      }
    });
    setSelectedFiles([]);
    updateData(newData);
  };
  const handleNewFolder = () => {
    setContextMenu(null);
    folderCreateContextModal.onOpen();
  };
  //#endregion

  const prepareFileListItems = () => {
    // if parentNode is null tree.nodes is prepared else parentNode.children

    const children = data[rootUUID].childUUIDs.map(uuid => ({
      uuid,
      ...data[uuid]
    }));
    return children.map(item => {
      let prefix;
      const folderItem = item;
      const fileItem = item;
      if (folderItem.isFolder) {
        prefix = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
          as: _FaFolder.FaFolder,
          boxSize: "16"
        });
      } else {
        const {
          mimeType,
          previewSrc,
          src
        } = fileItem;
        if (mimeType && mimeType.startsWith('image/')) {
          prefix = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Image, {
            as: _reactLazyLoadImageComponent.LazyLoadImage,
            boxSize: "16",
            src: previewSrc || src
          });
        } else if (mimeType && mimeType.startsWith('application/pdf')) {
          prefix = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
            as: _FaFilePdf.FaFilePdf,
            boxSize: "16"
          });
        } else {
          prefix = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
            as: _FaFile.FaFile,
            boxSize: "16"
          });
        }
      }
      return {
        prefix,
        name: item.name,
        modifiedAt: item.modifiedAt,
        fileSize: fileItem.size,
        isFolder: folderItem.isFolder
      };
    });
  };
  const prepareFileInfoBoxProps = () => {
    const uuid = resolveUUIDFromIndex(selectedFiles[0]);
    const item = data[uuid];
    const folderItem = item;
    const fileItem = item;
    let props = {
      onUpdate: handleFileInfoBoxUpdate,
      details: {
        fileName: item.name,
        fileType: folderItem.isFolder && 'Folder' || _mimeTypes.MimeTypes[fileItem.mimeType],
        fileSize: fileItem.size,
        createdAt: item.createdAt,
        modifiedAt: item.modifiedAt,
        description: item.description
      }
    };
    if (folderItem.isFolder) {
      props['previewElement'] = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
        as: _FaFolder.FaFolder,
        h: 200,
        w: 200
      });
    } else {
      const {
        mimeType,
        src,
        previewSrc
      } = fileItem;
      if (mimeType && mimeType.includes('image/')) {
        props['previewImageSrc'] = src;
      } else {
        if (previewSrc) {
          props['previewImageSrc'] = previewSrc;
        } else {
          props['previewElement'] = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
            as: _FaFile.FaFile,
            h: 200,
            w: 200
          });
        }
      }
    }
    return props;
  };

  // !BUG: useDropzone clashes with react-dnd dropzone inside of FileList component
  // This creates unnecessary re-rendering of this component when FileList dnd is used
  // (occures on drag and drop / click on rows)
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    acceptedFiles
  } = (0, _reactDropzone.useDropzone)({
    onDrop: handleUpload,
    maxSize: 5000000
  });
  (0, _react2.useEffect)(() => {
    if (isDragActive && isDragAccept) {
      toast({
        title: `Drop to upload ${acceptedFiles.length} file${acceptedFiles.length > 1 ? 's' : ''}`,
        status: 'info',
        isClosable: true,
        position: 'bottom-right'
      });
    }
  }, [isDragActive, isDragAccept, acceptedFiles.length]);
  const finderExtras = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [contextMenu && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
        pos: "absolute",
        top: contextMenu.spawnY,
        left: contextMenu.spawnX,
        zIndex: "popover",
        w: "3xs",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileContextMenu.default, {
          items: contextMenu.id !== undefined ? [{
            _type: 'ITEM',
            content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: "Select"
            }),
            onItemClick: handleFileOpen
          }, {
            _type: 'ITEM',
            content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: 'Rename'
            }),
            onItemClick: handleFileRename
          }, {
            _type: 'ITEM',
            content: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.HStack, {
              spacing: 2,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DeleteIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Text, {
                children: "Delete"
              })]
            }),
            onItemClick: handleFileDelete
          }] : [{
            _type: 'ITEM',
            content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: 'New folder'
            }),
            onItemClick: handleNewFolder
          }]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextModal.default, {
      title: "Create folder",
      inputPlaceholder: "Your new folder",
      finishBtnLabel: "Create",
      onFinish: handleFinishFolderCreate,
      isOpen: folderCreateContextModal.isOpen,
      onClose: folderCreateContextModal.onClose,
      onCancel: folderCreateContextModal.onClose
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextModal.default, {
      title: "Rename",
      inputPlaceholder: "File name",
      inputText: data[resolveUUIDFromIndex(selectedFiles[0])].name,
      finishBtnLabel: "Rename",
      onFinish: handleItemRename,
      isOpen: itemRenameContextModal.isOpen,
      onClose: itemRenameContextModal.onClose,
      onCancel: itemRenameContextModal.onClose
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Drawer, {
      isOpen: showInfoCard,
      onClose: infoCardToggle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.DrawerContent, {
        minW: "fit-content",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.DrawerCloseButton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.DrawerHeader, {
          children: "File info"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.DrawerBody, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileInfoBox.default, {
            ...prepareFileInfoBoxProps()
          })
        })]
      })
    })]
  });
  if (mode === 'selector' && props.onSelectorClose) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [finderExtras, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Modal, {
        isOpen: true,
        onClose: props.onSelectorClose,
        isCentered: true,
        scrollBehavior: "inside",
        size: "6xl",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalOverlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.ModalContent, {
          minH: "85vh",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalHeader, {
            children: "SnekFinder - Selector"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalCloseButton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
            px: 4,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toolbar.default, {
              view: "LIST",
              onViewToggleClick: () => null,
              onInfoToggleClick: infoCardToggle,
              breadcrumbs: parentNodeHistory,
              onBreadcrumbClick: switchParentNode,
              onBreadcrumbDnDMove: handleBreadcrumbMove,
              onUpload: handleUpload,
              onNewFolder: handleNewFolder
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalBody, {
            as: _react.Flex,
            flexDirection: "column",
            pt: 0,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
              flexGrow: 1,
              h: "100vh",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layout.Box, {
                ...getRootProps(),
                h: '100%',
                _focus: {
                  outline: 'none'
                },
                onClick: e => e.stopPropagation(),
                onContextMenu: e => {
                  e.preventDefault();
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                  ...getInputProps()
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileList.default, {
                  items: prepareFileListItems(),
                  onSelectionDoubleClick: handleFileOpen,
                  onSelectionChange: handleSelectionChange,
                  onContextMenu: handleContextMenu,
                  onDnD: handleListMove,
                  onContextMenuClose: () => setContextMenu(null)
                })]
              })
            })
          })]
        })]
      })]
    });
  }
  console.log(imagesWithoutPreview);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [finderExtras, imagesWithoutPreview.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImagePreviewWarningAlert.default, {
      imageCount: imagesWithoutPreview.length,
      onGeneratePreviews: async () => {
        // loop through imagesWithoutPreview and create preview for each

        const newData = {
          ...data
        };
        for (const uuid of imagesWithoutPreview) {
          const fileItem = newData[uuid];
          if (fileItem.mimeType && fileItem.mimeType.startsWith('image/')) {
            if (!fileItem.previewSrc) {
              // download image and create preview
              const fileBlob = await fetch(fileItem.src).then(r => r.blob());
              const uploaded = await props.onUploadFile(new File([fileBlob], `preview_${fileItem.name}`, {
                type: fileItem.mimeType
              }));
              fileItem.previewSrc = uploaded.previewSrc;
              newData[uuid] = fileItem;
              await new Promise(resolve => setTimeout(resolve, 1000));
            }
          } else {
            console.log('not image', fileItem);
          }
          console.log('newData', newData[uuid]);
          updateData({
            ...newData
          });
        }
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toolbar.default, {
      view: "LIST",
      onViewToggleClick: () => null,
      onInfoToggleClick: infoCardToggle,
      breadcrumbs: parentNodeHistory,
      onBreadcrumbClick: switchParentNode,
      onBreadcrumbDnDMove: handleBreadcrumbMove,
      onUpload: handleUpload,
      onNewFolder: handleNewFolder
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layout.Box, {
      ...getRootProps(),
      h: '90%',
      overflowY: "auto",
      _focus: {
        outline: 'none'
      },
      onClick: e => e.stopPropagation(),
      onContextMenu: e => {
        e.preventDefault();
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        ...getInputProps()
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileList.default, {
        items: prepareFileListItems(),
        onSelectionDoubleClick: handleFileOpen,
        onSelectionChange: handleSelectionChange,
        onContextMenu: handleContextMenu,
        onDnD: handleListMove,
        onContextMenuClose: () => setContextMenu(null)
      })]
    })]
  });
};
var _default = Finder;
exports.default = _default;